import client from '../../client'

const tokenConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`
  }
})

export function reqGetRegions(token) {
  return client().get('/api/regions',
    tokenConfig(token))
}

export function reqGetCommunes(token, regionId) {
  return client().get(`/api/regions/${regionId}/communes`,
    tokenConfig(token))
}

export function reqGetBanks(token) {
  return client().get('/api/banks',
    tokenConfig(token))
}

export function reqGetCitys(token, regionId) {

  // console.log(regionId);
  // console.log(typeof regionId);

  let nuevoId = regionId.toString();

  // console.log('Nuevo ID String', nuevoId);
  // console.log(typeof nuevoId);

  if (nuevoId.length === 2) {
    console.log('Tiene 2 digitos');
  } else {
    console.log('Tiene 1 digito');
    nuevoId = '0' + nuevoId;
    // console.log('Nuevo ID Region', nuevoId);
    // console.log(typeof nuevoId);
  }

  return client().get(`/api/catalogo-region/ciudades/${nuevoId}`,
    tokenConfig(token))

}
